<template>
  <luma-empty>
    <domain-details-view></domain-details-view>
  </luma-empty>
</template>

<script>
    import LumaEmpty from "@/layout/LumaEmpty";
    import DomainDetailsView from "./details_domain/domain-details-view";
    import LumaShowDomain from "./create_domain/luma-show-domain";
    import {DomainNameserver} from "@/store/models/domain/domain_nameserver";
    import {DomainHandle} from "@/store/models/domain/domain_handle";

    export default {
        name: "domain-details",
        components: {LumaShowDomain, DomainDetailsView, LumaEmpty},
        created() {
            DomainHandle.fetchall()
            DomainNameserver.fetch()
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/domain/domain-details.vue